import Instrument from "shared/games/instruments/Instrument";
import { FrequencyRange } from "./frequencyRange";

const frequencyRangesByInstrument: {
  [instrument in Instrument]: {
    instrument: Instrument;
    frequencies: Set<FrequencyRange>;
  };
} = {
  drm_kick: {
    instrument: Instrument.drmKick,
    frequencies: new Set([
      FrequencyRange.bass,
      FrequencyRange.lowMids,
      FrequencyRange.mids,
    ]),
  },

  drm_oh: {
    instrument: Instrument.drmOh,
    frequencies: new Set([
      FrequencyRange.lowMids,
      FrequencyRange.mids,
      FrequencyRange.hiMids,
      FrequencyRange.presence,
    ]),
  },

  drm_set: {
    instrument: Instrument.drmSet,
    frequencies: new Set([
      FrequencyRange.bass,
      FrequencyRange.lowMids,
      FrequencyRange.mids,
      FrequencyRange.hiMids,
      FrequencyRange.presence,
    ]),
  },

  drm_snare: {
    instrument: Instrument.drmSnare,
    frequencies: new Set([FrequencyRange.lowMids, FrequencyRange.mids]),
  },

  gtr_acc_fngrpck: {
    instrument: Instrument.gtrAccFingerPicked,
    frequencies: new Set([
      FrequencyRange.lowMids,
      FrequencyRange.mids,
      FrequencyRange.hiMids,
      FrequencyRange.presence,
    ]),
  },

  gtr_acc_lead: {
    instrument: Instrument.gtrAccLead,
    frequencies: new Set([
      FrequencyRange.lowMids,
      FrequencyRange.mids,
      FrequencyRange.hiMids,
      FrequencyRange.presence,
    ]),
  },

  gtr_acc_strum: {
    instrument: Instrument.gtrAccStrummed,
    frequencies: new Set([
      FrequencyRange.lowMids,
      FrequencyRange.mids,
      FrequencyRange.hiMids,
      FrequencyRange.presence,
    ]),
  },

  gtr_bass: {
    instrument: Instrument.gtrBass,
    frequencies: new Set([
      FrequencyRange.subBass,
      FrequencyRange.bass,
      FrequencyRange.lowMids,
      FrequencyRange.mids,
    ]),
  },

  synth_lead: {
    instrument: Instrument.synthLead,
    frequencies: new Set([
      FrequencyRange.lowMids,
      FrequencyRange.mids,
      FrequencyRange.hiMids,
      FrequencyRange.presence,
    ]),
  },

  synth_pad: {
    instrument: Instrument.synthPad,
    frequencies: new Set([
      FrequencyRange.lowMids,
      FrequencyRange.mids,
      FrequencyRange.hiMids,
      FrequencyRange.presence,
    ]),
  },

  string_ensemble: {
    instrument: Instrument.stringEnsemble,
    frequencies: new Set([
      FrequencyRange.lowMids,
      FrequencyRange.mids,
      FrequencyRange.hiMids,
      FrequencyRange.presence,
    ]),
  },

  perc_bongos: {
    instrument: Instrument.percBongos,
    frequencies: new Set([
      FrequencyRange.lowMids,
      FrequencyRange.mids,
      FrequencyRange.hiMids,
    ]),
  },

  perc_shaker: {
    instrument: Instrument.percShaker,
    frequencies: new Set([
      FrequencyRange.hiMids,
      FrequencyRange.presence,
      FrequencyRange.brilliance,
    ]),
  },

  perc_tambo: {
    instrument: Instrument.percTambo,
    frequencies: new Set([
      FrequencyRange.hiMids,
      FrequencyRange.presence,
      FrequencyRange.brilliance,
    ]),
  },

  vox_female: {
    instrument: Instrument.voxFemale,
    frequencies: new Set([
      FrequencyRange.lowMids,
      FrequencyRange.mids,
      FrequencyRange.hiMids,
      FrequencyRange.presence,
      FrequencyRange.brilliance,
    ]),
  },
};

export default frequencyRangesByInstrument;
